import { motion } from 'framer-motion';
import { Clock, Users, Award, Shield } from 'lucide-react';

const stats = [
  { number: '10+', label: 'Years Experience', icon: <Clock className="w-5 h-5" /> },
  { number: '500+', label: 'Clients Served', icon: <Users className="w-5 h-5" /> },
  { number: '₹1000Cr+', label: 'Funds Facilitated', icon: <Award className="w-5 h-5" /> },
  { number: '98%', label: 'Success Rate', icon: <Shield className="w-5 h-5" /> }
];

export const HomeStats = () => (
  <section className="py-20 bg-white" data-testid="stats-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
        {stats.map((stat, index) => (
          <motion.div
            key={stat.label}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="text-center"
          >
            <div className="inline-flex items-center justify-center w-12 h-12 bg-gradient-to-br from-[#3b5998] to-[#00bcd4] rounded-xl text-white mb-4">
              {stat.icon}
            </div>
            <p className="stat-number text-4xl lg:text-5xl font-semibold mb-2">{stat.number}</p>
            <p className="text-[#64748b] text-sm font-medium">{stat.label}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
